import { Genre, Instrument, Sfx, Maybe, Tag } from 'types/generated/graphql';

export type AttributeGroups = {
    customs?: Maybe<Maybe<string>[]>;
    genres?: Maybe<Maybe<Genre>[]>;
    instruments?: Maybe<Maybe<Instrument>[]>;
    sfxs?: Maybe<Maybe<Sfx>[]>;
    tags?: Maybe<Maybe<Tag>[]>;
};

export enum AttributeKind {
    Genre = 'genre',
    Instrument = 'instrument',
    Sfx = 'sfx',
    Custom = 'custom',
    Tag = 'tag',
}

export type Attribute = {
    kind: AttributeKind;
    code: string | undefined;
    displayName: string;
};

export type AttributeList = Attribute[];
